import { Link } from 'react-router-dom';
import { Logo } from './Logo.js';

/**
 * The three legal URLs are mandatory fields on the Meta app and a reviewer
 * reaches them from here, logged out. They are `Link`s rather than anchors so
 * the router serves them without a page load.
 */
const DOCUMENTS = [
  { label: 'Privacy', to: '/privacy' },
  { label: 'Terms', to: '/terms' },
  { label: 'Data deletion', to: '/data-deletion' },
];

export function Footer() {
  return (
    <footer className="relative z-10 w-full px-4 sm:px-6 pt-8 sm:pt-12 pb-8 sm:pb-12">
      <div className="mx-auto w-full max-w-5xl bg-paper/90 dark:bg-paper/85 backdrop-blur-sm border border-hairline shadow-sm px-5 sm:px-8 md:px-12 py-12 sm:py-16">
        <div className="flex items-center gap-2.5">
          <Logo className="w-6 h-6" />
          <span className="font-semibold text-base tracking-tight text-ink">Legate</span>
        </div>

        <div className="mt-6 text-sm text-ink/70">
          Legate · $LEGATE · Robinhood Chain · pons.family
        </div>

        <p className="mt-4 max-w-xl text-sm text-ink/50 leading-relaxed">
          Built on the official Meta APIs. Not a Meta partner and makes no claim of Meta endorsement.
        </p>

        <div className="mt-10 h-px bg-hairline w-full" />

        <div className="mt-6 flex flex-wrap items-center justify-between gap-4">
          <div className="text-[11px] uppercase tracking-[0.2em] text-ink/40 font-medium tabular">
            2026
          </div>
          <nav className="flex flex-wrap items-center gap-x-6 gap-y-2">
            {DOCUMENTS.map((doc) => (
              <Link
                key={doc.to}
                to={doc.to}
                className="text-sm text-ink/70 hover:text-ink transition-colors duration-200"
              >
                {doc.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
